// extracted by mini-css-extract-plugin
export default {"sortLabel":"CustomTableCell_sortLabel__6-+tD","icon":"CustomTableCell_icon__szc4S","icon--inactive":"CustomTableCell_icon--inactive__1aH3S"};